import { Button, Link } from "@mui/material";
import { FC, useContext } from "react";
import { useFormContext } from "react-hook-form";
import { useSetRecoilState } from "recoil";

import { EmailInputByControl } from "@ryde/controls";
import { useAuthActions } from "@ryde/redux";
import { Log, loginFlowStepAtom, LoginFormFlow } from "@ryde/shared";

import { LoginPageFormContext } from "../login.page.form.context";
import { textboxLoginSx } from "../login.page.styled";
import { useLoginTranslation } from "../use-login-translation";
import { getButtonLoginSx } from "./login.parts.styled";
import { useForceLoginParam } from "./use-force-login-param";

export const LoginSsoForm: FC = () => {
  const {
    getValues,
    trigger,
    formState: { errors },
  } = useFormContext();
  const { control } = useFormContext();
  const { t } = useLoginTranslation();
  const { handleSamlLogin, setLoginErrors } = useAuthActions();
  const { buttonLoginColor, isNonProductionLoginColors } =
    useContext(LoginPageFormContext);
  const setLoginFlowStep = useSetRecoilState(loginFlowStepAtom);
  const forceLogin = useForceLoginParam();

  const handleSsoLogin = (): void => {
    trigger()
      .then(() => {
        if (!errors.Email) {
          const { Email } = getValues();

          if (Email) {
            const emailDomain = Email.split("@")[1];
            handleSamlLogin({ emailDomain, forceLogin });
          }
        }
      })
      .catch(err => {
        const errorName = t("errors.LOGIN_ERROR");
        Log.error(errorName, err);
        setLoginErrors([`${errorName}: ${(err as Error)?.message}`]);
      });
  };

  return (
    <div className="LoginGenericForm">
      <div className="LoginGenericForm-FieldContainer">
        <div className="LoginGenericForm-LabelSignIn">
          {t("login.ENTER_YOUR_EMAIL")}
        </div>
        <EmailInputByControl
          control={control}
          name="Email"
          sx={textboxLoginSx}
          size="small"
        />
      </div>
      <Button
        data-e2e="button-login-saml"
        variant="contained"
        color={isNonProductionLoginColors ? "inherit" : buttonLoginColor}
        sx={getButtonLoginSx(isNonProductionLoginColors)}
        onClick={handleSsoLogin}
      >
        {t("login.LOGIN_WITH_SSO")}
      </Button>
      <Link
        style={{ cursor: "pointer" }}
        onClick={() => setLoginFlowStep(LoginFormFlow.GENERIC_STEP)}
      >
        ← {t("login.BACK")}
      </Link>
    </div>
  );
};
